<!-- =========================================================================================
    File Name: DialogsConfirm.vue
    Description: Create Confirm dialogs
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vx-card title="Pagamento de Boletos">
        
        <p>Digite a representação numérica constante no código de barras do seu boleto.</p>
        
        <vs-alert color="danger" icon="new_releases" active="true" class="my-4">
            <p>Verifique corretamente o número digitado. <code>Cuidado com fraudes, verifique se a instituição bancária é equivalente ao banco do boleto.</code></p>
        </vs-alert>
		<div class="vx-col w-full">
			<vs-input
				v-mask="['#####.##### #####.###### #####.###### # ##############']"
				data-vv-validate-on="blur"
				v-validate="'required|min:54'"
				name="boleto"
				label-placeholder="Código do Boleto" 
				placeholder="Código do Boleto"
				v-model="boleto"
				class="w-full mt-6"
				@blur="onBoleto"
				@keyup.enter="registerUser" />
			<span class="text-danger text-sm">{{ errors.first('boleto') }}</span>
		</div><br>
		<div class="op-block">Banco: {{ banco == null ? 'null' : banco }}</div><br>
		<div class="op-block">Valor: {{ val == null ? 'null' : val }}</div><br>
		<div class="op-block">Data de Vencimento: {{ vencimento == null ? 'null' : vencimento }}</div>
		<div class="vx-col w-full">
			<vs-input
				v-mask="['######']"
				data-vv-validate-on="blur"
				v-validate="'required'"
				name="pin"
				label-placeholder="Pin" 
				placeholder="Pin"
				v-model="pin"
				class="w-full mt-6" />
			<span class="text-danger text-sm">{{ errors.first('pin') }}</span>
		</div><br>

        <div class="demo-alignment">
            <vs-button @click="openConfirm()" color="danger" type="gradient">Realizar Pagamento</vs-button>
        </div>

        

    </vx-card>
</template>

<script>
import {mask} from 'vue-the-mask'
import {validarBoleto} from '@mrmgomes/boleto-utils'
export default {
	directives: {
		mask
	},
    data: () => ({
        activeConfirm: false,
		boleto: '',
		val:'',
		pin:'',
		var_float: '',
		banco:'',
		vencimento:'',
		valMultipe:{
			value1:'',
			value2:''
		}
    }),
    methods: {
		onBoleto() {
			var boletox = validarBoleto(this.boleto);
			console.log(boletox);
			try {
				var boleto = new Boleto(this.boleto);
				console.log(boleto);
				this.val = boleto.prettyAmount();
				this.val_float = boleto.amount();
				this.banco = boleto.bank();
				this.vencimento = boleto.expirationDate();
			}catch(e) {
				console.log(e);
				this.$vs.notify({
					color: 'danger',
					title: 'Pagamento Boleto',
					text: 'Número do boleto inválido!'
				})
			}
		},
        openConfirm() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirmação`,
                text: 'Confirma a solicitação de pagamento do boleto?',
                accept: this.acceptAlert
            })
        },
        acceptAlert() {
			try {
				var boleto = new Boleto(this.boleto);
				this.$vs.loading({
					type:'radius',
				})

				fetch(this.$store.state.API_URL + 'Financeiro/Pagamento/Boleto', {
					method: 'POST',
					headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
					body: "token="+localStorage.getItem("token")+"&boleto="+this.boleto+"&valor="+this.val_float+"&banco="+this.banco+"&pin="+this.pin
				})
				.then((response) => response.text())
				.then((responseData) => {
					var dados = JSON.parse(responseData);
					if(dados.done == true)
					{
						setTimeout( ()=> {
							this.$vs.loading.close();
							this.$vs.notify({
								title: 'SPSaude',
								text: dados.message,
								iconPack: 'feather',
								icon: 'icon-alert-circle',
								color: 'success'
							});
						}, 4000);

					}
					else
					{	
						setTimeout( ()=> {
							this.$vs.loading.close();
							this.$vs.notify({
								title: 'SPSaude',
								text: dados.message,
								iconPack: 'feather',
								icon: 'icon-alert-circle',
								color: 'warning'
							});

						}, 4000);
					}
					
				})
				.catch((error) => {
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: 'Erro ao efetuar a solicitação de pagamento do boleto',
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

					}, 4000);
				});

			}catch(e) {
				this.$vs.notify({
					color: 'danger',
					title: 'Pagamento Boleto',
					text: 'Número do boleto inválido!'
				})
			}
			
        },
    }
}
</script>